import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { kycDSPStatus } from '@screens/KYC/KYCDocuments/services/kycDocumentsService';
import { KYC_RESPONSE_STATUS, KYC_ERROR_MAP } from "@screens/KYC/utils";
import { removeUrlParamsWithoutReload, removeUrlWithoutReload } from "@app/utils";
import type { NativeStackNavigationProp } from "@react-navigation/native-stack";
import type { PrivateStackParamList } from "@app/navigationApp/types";
import { updateLinkedApplication } from "@app/store/slices/authSlice";

export const useKYCStatusHandler = (
  navigation: NativeStackNavigationProp<PrivateStackParamList, 'KYC_DIGIO_RESPONSE'>
) => {
  const userDetails = useAppSelector(state => state.auth.userDetails);

  const dispatch = useAppDispatch();

  useEffect(() => {
    removeUrlWithoutReload("kyc_response")
    removeUrlWithoutReload("status")
    removeUrlWithoutReload("digio_doc_id")
    removeUrlWithoutReload("message")
    removeUrlWithoutReload("error_code")
    const fetchKYCStatus = async () => {
      let errorConfig;
      let showSuccessCard = false;
      let showFailureCard = false;
      let failedTitle = undefined;
      let failedSubTitle = undefined;
      let currentStepId = "KYC_DOCUMENTS";
      try {
        const applicationId = userDetails?.linkedApplications[0]?.applicationId;
        if (!applicationId) return;
        const response = await kycDSPStatus({ applicationId });
        const stepResponseObject = response?.data?.stepResponseObject;
        currentStepId = response?.data?.updatedApplicationObj?.currentStepId;
        if (stepResponseObject === KYC_RESPONSE_STATUS.COMPLETED) {
          showSuccessCard = true;
          currentStepId = response?.data?.updatedApplicationObj?.currentStepId;
          dispatch(updateLinkedApplication(response?.data?.updatedApplicationObj))
        }
        else if (stepResponseObject === KYC_RESPONSE_STATUS.CREATED) {
          showFailureCard = true;
          errorConfig = KYC_ERROR_MAP[stepResponseObject] || KYC_ERROR_MAP.DEFAULT;
          failedTitle = 'KYC verification canceled';
          failedSubTitle = 'KYC verification is required for the completion of your loan application';
        }
        else {
          showFailureCard = true;
          errorConfig = KYC_ERROR_MAP[stepResponseObject] || KYC_ERROR_MAP.DEFAULT;
          failedTitle = errorConfig.failedTitle;
          failedSubTitle = errorConfig.failedSubTitle;
        }
      } catch (error: any) {
        const voltErrorCode = error?.data?.voltErrorCode;
        if (voltErrorCode === KYC_RESPONSE_STATUS.MISMATCH_DETECTED) {
          showFailureCard = true;
          errorConfig = KYC_ERROR_MAP[voltErrorCode] || KYC_ERROR_MAP.DEFAULT;
          failedTitle = errorConfig.failedTitle;
          failedSubTitle = error?.data?.message;
        } else {
          showFailureCard = true;
          errorConfig = KYC_ERROR_MAP[voltErrorCode] || KYC_ERROR_MAP.DEFAULT;
          failedTitle = errorConfig.failedTitle;
          failedSubTitle = errorConfig.failedSubTitle;
        }
      }
      navigation.navigate("KYC_DOCUMENTS", {
        showSuccessCard,
        showFailureCard,
        failedTitle,
        failedSubTitle,
        currentStepId,
      });
    };
    fetchKYCStatus();
  }, []);
}; 